export default "/img/VC.3c3343c40b37228d2d07217a813173dc.png";